const sendMessage = async (userWhatsAppNumber, message) => {
  try {
    const response = await fetch('https://us-central1-projeto-aplicativo-01.cloudfunctions.net/sendWhatsAppMessage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userWhatsAppNumber, message })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Erro ao enviar mensagem:', error);
    throw error;
  }
};

export default sendMessage;
